import { useQuery } from 'react-query';
import { GetCommunityCategories } from 'services/apiServices';
import { Errors, TCommunityCategoriesResult } from 'types/ApiServicesTypes';

export default function useGetCommunityCategories() {
  const objQuery = useQuery<TCommunityCategoriesResult, Errors>(
    ['GetCommunityCategories'],
    async () => {
      return await GetCommunityCategories();
    },
  );
  return objQuery;
} 